/**
 * @desc  숫자 3자리(천 단위) 포맷팅(ex. 1,999)
 * @param {*} number 숫자 1999
 * @returns 천 단위로 포맷팅된 값 1,999
 */
export const formatThreeComma = (number) => {
  if (number === null || number === undefined) return '0';
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * @desc 천 단위 포맷팅된 숫자 문자열을 숫자로 변환
 * @param {*} formattedNumber 포맷팅된 숫자 문자열(ex. '1,999')
 * @returns 숫자 값 1999
 */
export const removeThreeComma = (formattedNumber) => {
  return parseInt(formattedNumber.replace(/,/g, ""), 10);
};

/**
 * 숫자를 한국어 단위(천, 만, 억, 조)로 변환
 * 예: 123456789 → "1억 2345만 6789"
 * @param {number} number - 변환할 숫자
 * @returns {string} 변환된 문자열
 */
export const formatKorNumber = (number) => {
  if (!number || isNaN(number)) return "0";

  const units = ["", "만", "억", "조"];
  const splitUnit = 10000; // 1만 단위로 끊음
  const result = [];

  let restNumber = number;

  for (let i = 0; restNumber > 0; i++) {
    const part = restNumber % splitUnit;
    if (part !== 0) {
      // 0인 구간은 표시하지 않음
      result.unshift(`${part}${units[i]}`);
    }
    restNumber = Math.floor(restNumber / splitUnit);
  }

  return result.join(" ");
};
